<div class="kz-registerV2 kz-loginV2">
  <div class="kz-registerV2-container kz-loginV2-container">
    <div class="kz-registerV2-content kz-loginV2-content">
      <kz-icons name="kozikaza"></kz-icons>
      <h2 i18n="@@auth.forgotPassword.title">Forgot password ?</h2>
      <form class="kz-registerV2-form kz-loginV2-form" [formGroup]="forgotPasswordForm" (ngSubmit)="save()" novalidate appGtmTrack="{{ gtmForm }}" trackChildren="false">
          <ng-container *ngIf="forgotPasswordForm.get('emailOrPhone')">
            <kz-field class="kz-field-full" [hasError]="isFieldInvalid('emailOrPhone')">
              <label kzLabel isRequired="true" for="kz-login--account"i18n="@@auth.forgotPassword.email">Email</label>
              <input kzTextBox id="kz-login--account" type="text" (change)="updateEmail($event)" placeholder="Your email" i18n-placeholder="@@auth.forgotPassword.email.placeholder" formControlName="emailOrPhone"/>
              <p kzError *ngIf="isFieldInvalid('emailOrPhone')" i18n="@@auth.errors.required">Required</p>
            </kz-field>

            <div *ngIf="magicLinkAlreadySend" class="kz-field-full">
              <p kzFieldInfo i18n="@@auth.forgotPassword.emailSend">A reset email has been sent to: {{ forgotPasswordForm.get('emailOrPhone').value }}</p>
            </div>
          </ng-container>

          <div *ngIf="smsAlreadySend || (params && params.verification_code)" class="kz-field-full" [ngClass]="{'kz-field-error': isFieldInvalid('verification_code')}">
            <input kzTextBox id="kz-login--token" name="code" type="hidden" formControlName="verification_code"  placeholder="000000" />
            <p kzError *ngIf="isFieldInvalid('verification_code')"><span i18n="@@auth.errors.required">Required</span></p>
          </div>

          <div *ngIf="smsAlreadySend" class="kz-field-full">
            <p kzFieldInfo i18n="@@auth.login.code.phone">Enter your confirmation code. The reception of your code can take up to 1 minute</p>
          </div>

          <kz-field *ngIf="smsAlreadySend || (params && (params.verification_code || params.token))" class="kz-field-full kz-field-full--password" [hasError]="isFieldInvalid('password')">
            <label kzLabel i18n="@@auth.forgotPassword.password" isRequired="true">Your new password</label>
            <input kzTextBox name="password" [type]="(showPassword) ? 'text' : 'password'" formControlName="password"  i18n-placeholder="@@auth.forgotPassword.password.placeholder"  placeholder="Your new password"/>
            <span class="kz-field-suffix" (click)="showPassword= !showPassword"><kz-icons name="discover"></kz-icons></span>
            <p kzError *ngIf="isFieldInvalid('password') && forgotPasswordForm.get('password').errors?.required" i18n="@@auth.errors.required">Required</p>
            <p kzError *ngIf="isFieldInvalid('password') && forgotPasswordForm.get('password').errors?.pattern" i18n="@@auth.errors.password.pattern">
                The password must contain at least 8 characters and meet these 3 conditions<br>
                1 upper case<br>
                1 lower case<br>
                1 number
            </p>
          </kz-field>

          <div *ngIf="error && error?.message" class="kz-field-full">
            <p kzError><span>{{ error.message }}</span></p>
          </div>

          <div class="kz-field-buttons">
            <button type="button" kzButton buttonStyle="borderless" (click)="cancel()" [disabled]="submitted" i18n="@@auth.button.cancel" appGtmTrack="{{ gtmCancel }}">Cancel</button>
            <button type="submit" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" appGtmTrack="{{ gtmSubmit }}"><span i18n="@@auth.button.next">Next</span></button>
          </div>

      </form>
    </div>
    <app-legal-notice [whiteTxt]="true"></app-legal-notice>
  </div>
</div>

